import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles';
import { LoadingIndicator } from '.';
export const FacebookButton = (props) => {
    const { classObject, loading, disabled } = props;
    const onClick = (event) => {
        if (disabled)
            return;
        props.onClick && props.onClick(event);
    };
    return (React.createElement("div", { className: css(styles.container, classObject), onClick: onClick }, loading ? (React.createElement(LoadingIndicator, { size: 28, isWhite: true })) : (React.createElement(React.Fragment, null,
        React.createElement("img", { className: css(styles.facebookIcon), src: "/assets/images/icons/facebook_icon.png" }),
        " ",
        props.children))));
};
const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.Facebook,
        color: Colors.White,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        letterSpacing: '2px',
        fontSize: 16,
        fontWeight: 'bold',
        height: 48,
        borderRadius: 100,
        cursor: 'pointer',
    },
    facebookIcon: {
        margin: '0 7px 1px 0',
        width: 18,
    },
});
